<template>
  <div class="review-question">
    <div class="review-question__wrapper">
      <div
        class="review-question__question"
        :class="{ 'review-question__question--revealed': revealed }"
      >
        <IncorrectQuestionIcon class="review-question__incorrect-icon" />
        <div
          class="review-question__question-text"
          v-html="question.content"
        ></div>
        <div class="review-question__reveal-link" @click="revealed = !revealed">
          REVEAL CORRECT
        </div>
      </div>
      <transition name="slide">
        <div v-if="revealed" class="review-question__answers">
          <div
            v-for="answer in question.answers"
            :key="`review-question__answer-${answer.answer_id}`"
            class="review-question__answer"
            :class="{
              'review-question__answer--correct': answer.is_correct,
            }"
          >
            <span
              v-if="answer.is_selected_by_user"
              class="review-question__answer-check review-question__answer-check--correct"
            >
              <CheckboxTick />
            </span>
            <span v-else class="review-question__answer-check"></span>
            <div
              class="review-question__answer-text"
              v-html="answer.content"
            ></div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import IncorrectQuestionIcon from '@/assets/icons/course/quiz/incorrect_question.svg'
import CheckboxTick from '@/assets/images/certification/checkbox-tick.svg'

export default {
  name: 'ReviewQuestion',
  components: {
    IncorrectQuestionIcon: {
      ...IncorrectQuestionIcon,
      name: 'IncorrectQuestionIcon',
    },
    CheckboxTick: { ...CheckboxTick, name: 'CheckboxTick' },
  },
  props: {
    question: {
      type: Object,
      required: true,
    },
  },
  data: () => {
    return {
      revealed: false,
    }
  },
}
</script>

<style lang="scss" scoped>
.review-question {
  $this: &;
  &:last-child {
    border-bottom: none;
  }
  &__wrapper {
    display: flex;
    flex-wrap: wrap;
    flex: 1;
    max-width: 100%;
    &__question-text {
      @include tablet {
        max-width: 80%;
      }
    }
  }
  &__question {
    @include tablet {
      display: flex;
      flex: 1;
    }
    svg {
      display: none;
      @include tablet {
        display: block;
      }
      overflow: visible;
      transition: all 0.3s ease;
    }
    &--revealed {
      svg {
        transform: rotate(90deg);
        fill: var(--white);
      }
    }
  }
  &__reveal-link {
    font-size: 14px;
    white-space: nowrap;
    text-decoration: underline;
    cursor: pointer;
    padding-top: 5px;
    margin-left: auto;
  }
  &__question-text {
    font-size: 18px;
    @include tablet {
      margin: 0 100px 0 30px;
    }
    ::v-deep img {
      max-width: 100%;
    }
  }
  &__answers {
    margin: 20px 0;
    @include tablet {
      margin: 20px 80px;
    }
    width: 100%;
  }
  &__answer {
    padding: 10px 20px 0 10px;
    margin-bottom: 10px;
    position: relative;
    &-check {
      position: absolute;
      top: 10px;
      display: flex;
      align-self: flex-start;
      border-radius: 50%;
      width: 24px;
      height: 24px;
      border: 3px solid var(--tundora-gray);
      margin-right: 15px;
      &--correct {
        background: #0073cb 0% 0% no-repeat padding-box;
        border: 3px solid #0073cb;
        border-radius: 100px;
        align-items: center;
        justify-content: center;
        svg {
          transform: scale(0.8);
        }
      }
    }
    &-text {
      flex-grow: 1;
      padding-left: 40px;
      ::v-deep img {
        max-width: 100%;
      }
      ::v-deep code {
        white-space: pre-wrap;
        word-break: break-word;
        overflow-wrap: break-word;
        display: block;
        max-width: 100%;
      }
    }
    &--correct {
      background: #00dc9b12 0% 0% no-repeat padding-box;
      border: 1px solid #00dc9b;
      border-radius: 17px;
      #{$this}__answer-check {
        border: 3px solid var(--white);
        &--correct {
          border: 3px solid #0073cb;
        }
      }
      ::v-deep code {
        white-space: pre-wrap;
        word-break: break-word;
        overflow-wrap: break-word;
        display: block;
        max-width: 100%;
      }
    }
  }
}
</style>
